<template>
  <div id="services" class="services">
    <h2>
      Наши услуги и цены
    </h2>
    <div class="services__content">
      <div class="services__service services__service--wedding">
        <div class="services__service-info">
          <h3 class="services__service-title">Чистка диванов</h3>
          <div class="services__service-description">
            Профессиональная химчистка диванов любых размеров с помощью
            немецкой техники Kärcher и гиппоаллергенной химии известных брендов.
          </div>
          <table class="services__table">
            <tr>
              <td>2-х местный</td>
              <td>€20</td>
            </tr>
            <tr>
              <td>3-х местный</td>
              <td>€30</td>
            </tr>
            <tr>
              <td>4-х местный</td>
              <td>€35</td>
            </tr>
            <tr>
              <td>5-и местный и более</td>
              <td>от €40</td>
            </tr>
            <tr>
              <td>Диванная подушка</td>
              <td>€5</td>
            </tr>
          </table>
          <div class="services__service-actions">
            <a
                data-scroll
                href="#order"
                class="services__service-order-btn"
                @click="onServiceClick('свадебный фильм')"
            >
              Заказать чистку дивана
            </a>
          </div>
        </div>
        <div class="services__service-image-block">
          <img src="../assets/services/vacuum.jpg" alt="Чистка мебели и матрасов">
        </div>
      </div>

      <div class="services__service services__service--adv">
        <div class="services__service-image-block">
          <img src="../assets/services/armchairs.jpg" alt="Чистка кресел и стульев">
        </div>
        <div class="services__service-info">
          <h3 class="services__service-title">Чистка кресел и стульев</h3>
          <div class="services__service-description">
            Химчистка кресел и стульев – один из способов дать вторую жизнь вашей мебели.
          </div>
          <table class="services__table">
            <tr>
              <td>Стул</td>
              <td>€5</td>
            </tr>
            <tr>
              <td>Кресло</td>
              <td>€15</td>
            </tr>
            <tr>
              <td>Пуф</td>
              <td>€7</td>
            </tr>
          </table>
          <div class="services__service-actions">
            <a
                data-scroll
                href="#order"
                class="services__service-order-btn"
                @click="onServiceClick('рекламный ролик')"
            >
              Заказать чистку
            </a>
          </div>
        </div>
      </div>

      <div class="services__service services__service--adv">
        <div class="services__service-info">
          <h3 class="services__service-title">Чистка ковров и напольных покрытий</h3>
          <div class="services__service-description">
            Гиппоаллергенная чистка ковров с помощью высококачественной немецкой техники и химии Kärcher.
          </div>
          <table class="services__table">
            <tr>
              <td>С коротким ворсом</td>
              <td>€3/м²</td>
            </tr>
            <tr>
              <td>С длинным ворсом</td>
              <td>€5/м²</td>
            </tr>
          </table>
          <div class="services__service-actions">
            <a
                data-scroll
                href="#order"
                class="services__service-order-btn"
                @click="onServiceClick('рекламный ролик')"
            >
              Заказать чистку ковра
            </a>
          </div>
        </div>
        <div class="services__service-image-block">
          <img src="../assets/services/carpet.jpg" alt="Чистка ковра">
        </div>
      </div>

      <div class="services__service services__service--adv">
        <div class="services__service-image-block">
          <img src="../assets/services/mattress.jpg" alt="Чистка матрасов">
        </div>
        <div class="services__service-info">
          <h3 class="services__service-title">Чистка матрасов</h3>
          <div class="services__service-description">
            Регулярная чистка матрасов – очень важная и необходимая процедура для удаления пятен
            и клещей со спальных мест.
          </div>
          <table class="services__table">
            <tr>
              <td>Детский (60x120)</td>
              <td>€10</td>
            </tr>
            <tr>
              <td>Односпальный (80x190)</td>
              <td>€10</td>
            </tr>
            <tr>
              <td>Полутораспальный (100х190)</td>
              <td>€15</td>
            </tr>
            <tr>
              <td>Двуспальный (160х200)</td>
              <td>€20</td>
            </tr>
          </table>
          <div class="services__service-actions">
            <a
                data-scroll
                href="#order"
                class="services__service-order-btn"
                @click="onServiceClick('рекламный ролик')"
            >
              Заказать чистку матраса
            </a>
          </div>
        </div>
      </div>

      <div class="services__service services__service--music">
        <div class="services__service-info">
          <h3 class="services__service-title">Чистка салона авто и яхт</h3>
          <div class="services__service-description">
            Закажите химчистку салона автомобиля или интерьера яхт.
          </div>
          <table class="services__table">
            <tr>
              <td>Легковой автомобиль</td>
              <td>€40</td>
            </tr>
            <tr>
              <td>Минивэн</td>
              <td>от €50</td>
            </tr>
            <tr>
              <td>Яхта</td>
              <td>от €40</td>
            </tr>
          </table>
          <div class="services__service-actions">
            <a
                data-scroll
                href="#order"
                class="services__service-order-btn"
                @click="onServiceClick('видеоблог, интервью')"
            >
              Освежить интерьер
            </a>
          </div>
        </div>
        <div class="services__service-image-block">
          <img src="../assets/services/auto.jpg" alt="Чистка салона авто">
        </div>
      </div>

      <div class="services__service services__service--blog">
        <div class="services__service-image-block">
          <img src="../assets/services/general.jpg" alt="Уборка помещений">
        </div>
        <div class="services__service-info">
          <h3 class="services__service-title">Уборка помещений</h3>
          <div class="services__service-description">
            Комплексная уборка помещений и регулярная поддержка чистоты вашего интерьера.
          </div>
          <table class="services__table services__table--small">
            <tr>
              <th></th>
              <th class="breakable">Поддерживающая уборка</th>
              <th class="breakable">Генеральная уборка</th>
              <th class="breakable">Уборка после ремонта</th>
            </tr>
            <tr>
              <th>до 40 м²</th>
              <td>€30</td>
              <td>€50</td>
              <td>€80</td>
            </tr>
            <tr>
              <th>до 60 м²</th>
              <td>€40</td>
              <td>€70</td>
              <td>€110</td>
            </tr>
            <tr>
              <th>до 80 м²</th>
              <td>€50</td>
              <td>€90</td>
              <td>€140</td>
            </tr>
            <tr>
              <th>до 120 м²</th>
              <td>€70</td>
              <td>€130</td>
              <td>€200</td>
            </tr>
            <tr>
              <th>до 200 м²</th>
              <td>€110</td>
              <td>€210</td>
              <td>€320</td>
            </tr>
          </table>
          <p>Площади свыше обговариваются индивидуально</p>
          <div class="services__service-actions">
            <a
                data-scroll
                href="#order"
                class="services__service-order-btn"
                @click="onServiceClick('музыкальный клип')"
            >
              Убраться в помещении
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'our-services',
  methods: {
    onServiceClick(service) {
      // тип услуги, которую выбрал клиент
      window.ym(56986741, 'reachGoal', 'T_SELECT', { service });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/vars';

.services {
  border-top: 1px solid $color-border;
  padding-bottom: 40px;

  &__content {
    max-width: 1440px;
    margin: 0 auto;
  }

  &__service {
    display: flex;
    align-items: center;
    padding: 0 80px;
    margin-top: 60px;
    justify-content: space-between;

    &:first-child {
      margin-top: 0;
    }

    @media (max-width: 767px) {
      flex-wrap: wrap;
    }

    @media (max-width: 1023px) {
      padding: 0 20px;
    }
  }

  &__service-info {
    flex-basis: 40%;
    margin: 0 10px;

    @media (max-width: 767px) {
      flex-basis: 100%;
      order: 2;
      text-align: center;
      margin: 0;
    }

    @media (min-width: 768px) and (max-width: 1023px) {
      flex-basis: 60%;
    }
  }

  &__service-image-block {
    height: 400px;
    position: relative;
    box-shadow: 0 0 15px 2px rgba(0, 0, 0, 0.15);
    border-radius: 15px;
    margin: 0 10px;

    img {
      max-width: 100%;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 15px;
    }

    @media (max-width: 767px) {
      order: 1;
      flex-basis: 100%;
      margin: 0;
    }
  }

  &__service-title {
    font-weight: 900;
    font-size: 28px;
    line-height: 44px;
  }

  &__service-description {
    line-height: 26px;
    font-size: 18px;
    font-weight: 400;
    margin-top: 12px;
  }

  &__table {
    border-collapse: collapse;
    margin-top: 20px;

    td {
      border: 1px solid #eee;
      padding: 8px 20px;
    }

    th.breakable {
      word-break: break-word;
    }

    &--small th {
      font-size: 12px;
      line-height: 16px;
    }
  }

  &__service-actions {
    margin-top: 24px;
  }

  &__service-order-btn {
    display: inline-block;
    border-radius: 26px;
    text-decoration: none;
    color: $color-primary;
    background: white;
    border: 3px solid $color-primary;
    font-size: 16px;
    padding: 14px 20px;
    font-weight: 900;
    outline: none;
    cursor: pointer;

    &:hover {
      background-color: $color-primary;
      color: white;
    }
  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .services {
    &__service-info {
      margin-top: 20px;
    }

    &__service-title {
      font-size: 20px;
    }

    &__service-description {
      font-size: 16px;
    }
  }
}
</style>
